import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Route,
} from "react-router-dom";
import Router from "./Router";

const ErrorFallback = () => {
  return <h1>Oops! Something went wrong. Please try again later.</h1>;
};

export default function DataRouter() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route
        path="/*"
        element={<Router />}
        errorElement={<ErrorFallback />}
      />
    )
  );

  return <RouterProvider router={router} />;
}